import { b as BvCarouselEvent, B as BvEvent, a as BvTriggerableEvent } from "./classes-B4vxmOuN.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BvCarouselEvent,
  BvEvent,
  BvTriggerableEvent
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-BX_D-pjb.mjs.map
